export const bookingCharges = {
  header: {
    title: "Positionen",
    titleNew: "Neue Positionen",
    sub: "Posten, die auf die Rechnung des Gastes kommen.",
    subNew:
      "Für die nächste Rechnung. Die bereits abgerechnete Unterkunft steht oben auf ihrer Rechnung.",
  },
  loading: "Positionen werden geladen…",
  empty: {
    title: "Keine Positionen erfasst",
    titleBilled: "Keine offenen Positionen",
    sub: "Fügen Sie Unterkunft, Reinigung, Extras oder andere Leistungen hinzu.",
    subBilled: "Fügen Sie eine Position hinzu, um für diese Buchung eine weitere Rechnung zu erstellen.",
  },
  buttons: {
    addCharge: "Position hinzufügen",
    addFirstCharge: "Erste Position hinzufügen",
    manage: "Verwalten",
    manageTemplatesTitle: "Vorlagen verwalten",
    add: "Hinzufügen",
    close: "Schließen",
    cancel: "Abbrechen",
    saving: "Wird gespeichert…",
    saveCharge: "Position speichern",
    saveChanges: "Änderungen speichern",
    deleting: "Wird gelöscht…",
    confirmDelete: "Ja, löschen",
    editTitle: "Bearbeiten",
    deleteTitle: "Löschen",
  },
  table: {
    item: "Posten",
    qty: "Menge",
    unitPrice: "Einzelpreis",
    vat: "MwSt.",
    total: "Summe",
  },
  chips: {
    lodging: "Unterkunft",
    discount: "Rabatt",
    autoSynced: "Automatisch synchronisiert",
  },
  // Resumen de la estancia bajo cada habitación.
  stay: {
    nights: "1 Nacht | {n} Nächte",
    rooms: "1 Zimmer | {n} Zimmer",
  },

  fields: {
    // De qué habitación es el cargo (reservas de varias habitaciones).
    room: "Zimmer",
    roomAll: "Die ganze Buchung",
    roomHint: "Gehört er zu einem Zimmer, erscheint er auf dessen Rechnung.",
    date: "Datum",
    category: "Kategorie",
    quantity: "Menge",
    unitPriceFull: "Einzelpreis",
    vatPct: "MwSt. (%)",
    name: "Bezeichnung",
    price: "Preis",
    internalNotes: "Interne Notizen",
    paymentMethod: "Zahlungsart",
    paymentDate: "Zahlungsdatum",
    guestCount: "Anzahl der Gäste",
  },
  placeholders: {
    item: "Posten auswählen oder eingeben…",
    egCleaning: "z. B. Reinigung",
    internalNote: "Interne Notiz hinzufügen…",
  },
  templates: {
    savedTitle: "Gespeicherte Positionen",
    noResults: 'Keine Treffer für "{query}"',
    emptyPre: "Keine gespeicherten Positionen. ",
    createOne: "Eine anlegen",
    manageTitle: "Eigene Positionen",
    manageSub: "Legen Sie wiederverwendbare Positionen für Ihre Rechnungen an.",
    emptyList: "Keine gespeicherten Positionen. Legen Sie oben die erste an.",
    noCategory: "Ohne Kategorie",
  },
  vat: {
    labelPct: "MwSt. {rate} %",
  },
  modal: {
    editTitle: "Position bearbeiten",
    addSub: "Neuer Posten für die Rechnung",
    editSub: "Details der Position bearbeiten",
    totalCalculated: "Berechnete Summe",
  },
  common: {
    optional: "(optional)",
    unspecified: "Nicht angegeben",
  },
  invoice: {
    sectionLabel: "Elektronische Rechnung",
  },
  footer: {
    pending: "Noch nicht abgerechnet",
    totalDue: "Fälliger Gesamtbetrag",
  },
  deleteModal: {
    title: "Position löschen?",
    sub: "Diese Aktion kann nicht rückgängig gemacht werden.",
  },
  autoCategory: {
    service: "Leistung",
    fee: "Gebühr",
    extraGuest: "Zusatzgast",
    tax: "Steuer",
    cityTax: "Kurtaxe",
    adjustment: "Korrektur",
    autoFallback: "Automatische Position",
  },
  chargeBasis: {
    percentOfTotal: "Prozentsatz der Summe",
    perNight: "Pro Nacht",
    perPerson: "Pro Person",
    perPersonPerNight: "Pro Person und Nacht",
    perStay: "Pro Buchung",
  },
  toast: {
    descRequired: "Die Beschreibung ist erforderlich.",
    chargeAdded: "Position hinzugefügt.",
    chargeUpdated: "Position aktualisiert.",
    chargeDeleted: "Position gelöscht.",
    chargeSaved: "Position gespeichert.",
    saveFailed: "Speichern nicht möglich.",
    deleteFailed: "Löschen nicht möglich.",
    warningTitle: "Achtung",
    doneTitle: "Fertig",
    errorTitle: "Fehler",
  },
  invoices: {
    title: "Ausgestellte Rechnungen",
    noName: "Ohne Namen",
    conceptCount: "{count} Posten | {count} Posten",
    viewPdf: "PDF ansehen",
    sendWhatsapp: "Per WhatsApp senden",
    correct: "Berichtigen (Berichtigungsrechnung)",
    void: "Stornieren (Berichtigungsrechnung)",
    conceptsFoot:
      "Diese Posten sind bereits abgerechnet. Im PDF steht die vollständige Aufstellung.",
  },
  status: {
    draft: "Entwurf",
    sent: "Ausgestellt",
    processing: "In Bearbeitung",
    pending: "Ausstehend",
    error: "Fehler",
    corrected: "Berichtigt",
    voided: "Storniert",
  },
  checkinModal: {
    title: "Registrierungsdaten",
    bookingLink: "Buchung #{code}",
    requestDate: "Datum der Anfrage: {date} um {time}",
  },
  payment: {
    desti: "Zahlung vor Ort",
    efect: "Bar",
    movil: "Mobile Zahlung",
    otro: "Andere Zahlungsarten",
    platf: "Zahlungsplattform",
    tarjt: "Kreditkarte",
    trans: "Banküberweisung",
    treg: "Geschenkkarte",
  },
};
